import { getFormattedStoriesOrder } from './storyHelper'

export class ExhibitClient {
  constructor({ url, _get }) {
    this.url = url
    this.get = _get
  }

  help() {
    console.log('getById(id)')
    console.log('getShallowById(id)')
    console.log('getAllByOrgId(orgId)')
    console.log('getSortOrders(exhibit)')
    console.log('getSortOrderName(label)')
    console.log('getSortOrderLabel(name)')
  }

  fallback() {
    return {result: {status: 'HIDDEN'}}
  }

  async getById(id) {
    const url = await `${this.url}/api/app/get/${id}`
    const res = await this.get(url, this.fallback())
    let app = res.result
    if(app.status !== 'HIDDEN'){
      app.storiesOrder = getFormattedStoriesOrder(app.storiesOrder)
    }

    return app
  }

  async getShallowById(id) {
    const url = await `${this.url}/api/app/${id}/shallow`
    const res = await this.get(url, this.fallback())

    return res.result
  }

  async getAllByOrgId(orgId) {
    const url = await `${this.url}/api/organization/get-apps/${orgId}`
    const res = await this.get(url, { result: []})

    return res.result
  }

  getSortOrders(exhibit) {

    if(!exhibit || !exhibit.template?.name) return []

    const templateName = exhibit.template.name

    if(['david', 'lflb'].includes(templateName)) {
      return [{
        name: 'recently-added',
        label: 'Recently Added'
      }, {
        name: 'chronological',
        label: 'Chronological'
      }]
    }

    return [{
      name: 'recently-added',
      label: 'Recently Added'
    }, {
      name: 'oldest-first',
      label: 'Oldest First'
    }, {
      name: 'chronological',
      label: 'Chronological'
      }, {
        name: 'random',
        label: 'Random'
    }]
  }

  static getSortOrderName(label) {
   label = (label || '').toLowerCase().split(' ').join('-')
    return this.lookup(label)[1]
  }

  static getSortOrderLabel(name) {
    return this.lookup(name)[0]
  }

  static lookup(term) {
    let record

    switch(term) {
      case 'recently-added':
        record = ['Recently Added', 'recently-added']
        break
      case 'chronological':
        record = ['Chronological', 'chronological']
        break
      case 'oldest-first':
        record = ['Oldest First', 'oldest-first']
        break
      case 'random':
        record = ['Random', 'random']
        break
      default:
        record = ['Recently Added', 'recently-added']
    }

    return record
  }
}
